export const stateName = 'feedback';
export const COMMENT_CHAR_LIMIT = 400;
export let FeedbackScreen;

(function (FeedbackScreen) {
  FeedbackScreen["View"] = "VIEW";
  FeedbackScreen["DeleteFeedback"] = "DELETE_FEEDBACK";
  FeedbackScreen["CreateComment"] = "CREATE_COMMENT";
  FeedbackScreen["EditComment"] = "EDIT_COMMENT";
  FeedbackScreen["DeleteComment"] = "DELETE_COMMENT";
})(FeedbackScreen || (FeedbackScreen = {}));